import React, {useState, useEffect} from "react";
import axios from "axios";

import TopNav from "../components/TopNav";
import "./GlobalVisa.css";

import Visa from "../components/Visa";

const GlobalVisa = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
      getVisas();
      return () => {}
    }, [])

    const getVisas = async (obj) => {
        try {
            console.log("getVisas()")
            setLoading(true);
            // const request = "https://fdxva.org/api/get_visas.php?&rnd=" + Math.random();
            // const result = await axios(request);
            const response = await axios.get("/api/get_visas", {
            params: { _t: Date.now() }
            });                                 
            console.log(response.data.visas)
            setData(response.data.visas); 
        }
        catch (e) {
            console.log(e)
            setError(e);
            setData([]); 
        }
        finally{
            setLoading(false); // Stop loading after any error
        }
    }    

    const totalVisas = data ? data.length : 0;
    const earnedVisas = data ? data.filter(item => item.epoch !== null) : [];
    const unearnedVisas = data ? data.filter(item => item.epoch === null) : [];
    const visasEarned = earnedVisas.length;
    const visasRemaining = unearnedVisas.length;
    const progressPercentage = totalVisas > 0 ? Math.round((visasEarned / totalVisas) * 100) : 0;

    // Find the most recently earned visa (highest epoch value)
    const mostRecentEpoch = earnedVisas.length > 0
        ? Math.max(...earnedVisas.map(v => Number(v.epoch)))
        : null;

    const mostRecentVisa = mostRecentEpoch !== null
        ? earnedVisas.find(v => Number(v.epoch) === mostRecentEpoch)
        : null;

    const mostRecentDate = mostRecentEpoch !== null
        ? new Date(mostRecentEpoch * 1000)
        : null;

    const daysAgo = mostRecentDate !== null
        ? Math.floor((Date.now() - mostRecentDate.getTime()) / (1000 * 60 * 60 * 24))
        : null;

    const mostRecentDateStr = mostRecentDate !== null
        ? mostRecentDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })
        : null;

    return(

        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <div className="globalVisa">
                <div className={`globalVisa__stats ${props.darkmode ? 'globalVisa__stats--dark' : ''}`}>
                    <div className="globalVisa__stat-card">
                        <span className="globalVisa__stat-value">{totalVisas}</span>
                        <span className="globalVisa__stat-label">Total Visas</span>
                    </div>
                    <div className="globalVisa__stat-card">
                        <span className="globalVisa__stat-value">{visasEarned}</span>
                        <span className="globalVisa__stat-label">Visas Earned</span>
                    </div>
                    <div className="globalVisa__stat-card">
                        <span className="globalVisa__stat-value">{visasRemaining}</span>
                        <span className="globalVisa__stat-label">Visas Remaining</span>
                    </div>
                </div>
                <div className="globalVisa__progress-container">
                    <div className="globalVisa__progress-header">
                        <span className="globalVisa__progress-title">Progress</span>
                        <span className="globalVisa__progress-percentage">{progressPercentage}%</span>
                    </div>
                    <div className="globalVisa__progress-bar">
                        <div
                            className="globalVisa__progress-fill"
                            style={{ width: `${progressPercentage}%` }}
                            aria-valuenow={progressPercentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            role="progressbar"
                        />
                    </div>
                </div>

                {mostRecentVisa && (
                    <div className={`globalVisa__recent ${props.darkmode ? 'globalVisa__recent--dark' : ''}`}>
                        <div className="globalVisa__recent-star">★</div>
                        <div className="globalVisa__recent-info">
                            <span className="globalVisa__recent-label">Most Recent Visa</span>
                            <span className="globalVisa__recent-country">
                                {mostRecentVisa.flag && (
                                    <img
                                        className="globalVisa__recent-flag"
                                        src={`${process.env.PUBLIC_URL}/flags/${mostRecentVisa.flag}.svg`}
                                        alt={`${mostRecentVisa.country} flag`}
                                    />
                                )}
                                {mostRecentVisa.country}
                            </span>
                            <span className="globalVisa__recent-detail">
                                {mostRecentDateStr} — {daysAgo === 0 ? "Today" : daysAgo === 1 ? "1 day ago" : `${daysAgo} days ago`}
                            </span>
                            {mostRecentVisa.icao && (
                                <span className="globalVisa__recent-icao">Port of Entry: {mostRecentVisa.icao}</span>
                            )}
                        </div>
                    </div>
                )}

                {unearnedVisas.length > 0 && (
                    <div className={`globalVisa__unearned ${props.darkmode ? 'globalVisa__unearned--dark' : ''}`}>
                        <h3 className="globalVisa__unearned-title">
                            Countries Not Yet Visited ({unearnedVisas.length})
                        </h3>
                        <ul className="globalVisa__unearned-list">
                            {unearnedVisas.map((visa, index) => (
                                <li key={index} className="globalVisa__unearned-item">
                                    {visa.flag && (
                                        <img
                                            className="globalVisa__unearned-flag"
                                            src={`${process.env.PUBLIC_URL}/flags/${visa.flag}.svg`}
                                            alt={`${visa.country} flag`}
                                            loading="lazy"
                                        />
                                    )}
                                    <span className="globalVisa__unearned-country">{visa.country}</span>
                                    {visa.icao && (
                                        <span className="globalVisa__unearned-icao">{visa.icao}</span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="globalVisa__grid" aria-busy={loading ? "true" : "false"}>
                    {earnedVisas.map((visa, index) => (
                        <div
                            key={index}
                            className={
                                Number(visa.epoch) === mostRecentEpoch
                                    ? "globalVisa__card-wrapper globalVisa__card-wrapper--latest"
                                    : "globalVisa__card-wrapper"
                            }
                        >
                            {Number(visa.epoch) === mostRecentEpoch && (
                                <div className="globalVisa__latest-badge">★ Most Recent Visa</div>
                            )}
                            <Visa visa={visa} />
                        </div>
                    ))}
                </div>
            </div>
            {error}
        </React.Fragment>
    )

}
export default GlobalVisa;

